import {
  ArrowRightOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Form, Input, message } from "antd";
import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/tlogo.png";
import timeseraLogo from "../Assets/timesers-logo.png";
import { CREATE_jwel } from "../Config/Config";
import style from "./LoginPage.module.css";

const LoginPage = ({ onLogin }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("tenantName")) {
      navigate("/home");
    } else {
      navigate("/");
    }
  }, [navigate]);

  const userAPI = async (name) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=FIRM_CONFIGURE`,
        {
          headers: {
            tenantName: name,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        const imageUrls = data[0]?.EPASS1.split(",");
        localStorage.setItem("images", imageUrls);
        localStorage.setItem("user", data[0]?.FIRMNAME);
        localStorage.setItem("city", data[0]?.CITY);
        localStorage.setItem("singleImage", data[0]?.EPASS2);
        localStorage.setItem("gstValue", data[0]?.GST);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const onFinish = async (values) => {
    const { username, password } = values;
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/Tenant/CheckValidTenant?userName=${username}&password=${password}`,
      );

      if (response?.data) {
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userName", username);
        localStorage.setItem("tenantName", response?.data);
        onLogin(response?.data);
        userAPI(response?.data);
        userConditionAPI(values, response?.data);
        navigate("/home");
      } else {
        message.error("Invalid username or password");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const userConditionAPI = async (values, name) => {
    const { username } = values;
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=LOGINUSER_PROFILE&where=USERNAME='${username}'`,
        {
          headers: {
            tenantName: name,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        localStorage.setItem("userType", data[0].USER_TYPE);
        localStorage.setItem("ipAddress", data[0].PRINTERIP);
        localStorage.setItem("printModel", data[0].PRINT_MODEL);
        localStorage.setItem("pdfModule", data[0].PRINTQUALITY);
        localStorage.setItem("loginName", data[0].USERNAME);
        localStorage.setItem("wastMc", data[0].WAST_MC);
        localStorage.setItem("upiId", data[0].SOFT_CALCMCWITH);
        localStorage.setItem("jewel", data[0].INVOICE_GEN_MODEL);
        localStorage.setItem("adminType", data[0]?.WAST_MC);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className={style.loginContainer}>
      {/* Top Dark Header & Logos */}
      <div className={style.topSection}>
        <div className={style.circleTopLeft} />
        <div className={style.circleBottomRight} />

        <div className={style.logoWrapper}>
          <img src={logo} alt="Logo" className={style.mainIconLogo} />
          <img
            src={timeseraLogo}
            alt="Timesera Logo"
            className={style.brandTextLogo}
          />
        </div>
      </div>

      {/* Bottom White Card */}
      <div className={style.formCard}>
        <div className={style.cardHandle} />

        <h2 className={style.welcomeTitle}>Welcome Back</h2>
        <p className={style.welcomeSubtitle}>Sign in to your account</p>

        <Form
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{ remember: true }}
          requiredMark={false}
          className={style.loginForm}
        >
          <Form.Item
            label={<span className={style.fieldLabel}>USERNAME</span>}
            name="username"
            rules={[{ required: true, message: "Please enter your username" }]}
          >
            <Input
              prefix={<UserOutlined className={style.inputIcon} />}
              placeholder="Enter your username"
              className={style.customInput}
            />
          </Form.Item>

          <Form.Item
            label={<span className={style.fieldLabel}>PASSWORD</span>}
            name="password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <Input.Password
              prefix={<LockOutlined className={style.inputIcon} />}
              placeholder="Enter your password"
              className={style.customInput}
            />
          </Form.Item>

          <Form.Item style={{ marginTop: "24px", marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              className={style.submitBtn}
            >
              <span>Sign In</span>
              <ArrowRightOutlined style={{ fontSize: "16px" }} />
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginPage;
